import { COMMON_MESSAGE, GRID_ROWS_PER_PAGE } from '../../../../../constants';

export const priceClassSearch = {
  name: '',
  description: '',
  pageNumber: GRID_ROWS_PER_PAGE.initialIndex,
  pageSize: GRID_ROWS_PER_PAGE.priceClassesSearch,
  active_Flag : COMMON_MESSAGE.yes,
};

export const serviceOfferingsData = {
  contractId: 0,
  contractFeeTypeId: 0,
  contractZoneId: 0,
  priceClassId: 0,
  recordCount: GRID_ROWS_PER_PAGE.initialIndex,
  pageIndex: GRID_ROWS_PER_PAGE.priceClassesSearch,
};

export const deferralPriceclasses = {
  accountingGroup: '',
  pricingTypeId: 1,
  pricingClassId: 0,
  recordCount: 100,
  pageIndex: 1,
};
export const zones = [
  {
    contractZoneId: 0,
    zoneName: '',
    zoneDescription: '',
    lastModifiedUserId: 0,
    lastModifiedTimestamp: '',
  },
];
export const priceClasses = [
  {
    contractId: 0,
    priceClassId: 0,
    lastModifiedUserId: 0,
    lastModifiedTimestamp: '',
    prepaymentFlag: '',
    prepaymentDurationDays: 0,
    autoRenewFlag: '',
    extendedServicesDurationDays: 0,
    effectiveDate: '',
    deferralServiceOfferingId: 0,
    deferralServiceOfferingAddonId: 0,
    contractZoneId: 0,
    isInserted: true,
    isDeleted: false,
  },
];

export const serviceOfferings = [
  {
    contractId: 0,
    priceClassId: 0,
    contractFeeTypeId: 0,
    contractZoneId: 0,
    serviceOfferingId: 0,
    firstModifiedUserId: 0,
    lastModifiedUserId: 0,
    firstModifiedTimestamp: '',
    lastModifiedTimestamp: '',
    annualFee: 0,
    durationDays: 0,
    additionalFee: 0,
    isInserted: true,
    isUpdated: false,
    isDeleted: false,
  },
];

export const saveData = {
  contractFeeTypeId: 0,
  zones: [],
  priceClasses: [],
  serviceOfferings: []
};

// Fetch Contract price classes Payload
export const getContractsPricleClassPayload = {
  contractId: 0,
  contractFeeTypeId: 0,
  contractZoneId: 0,
  pageIndex: 0,
  recordCount: 0
};
// Fetch Contract price classes optiona payload
export const getPriceClassWithServices = {
  contractId: 0,
  priceClassId:0,
  recordCount:0,
  pageIndex: 0,
};

// Fetch Contract price classes optiona payload
export const getContractPriceClassService = {
  contractId: 0,
  contractFeeTypeId:0,
  contractZoneId :0,
  priceClassId:0,
  recordCount:0,
  pageIndex: 0,
};

export const zoneTab= { 
  contractZoneId: 0,
  contractZoneName: '',
  contractZoneNameDisplay: '',
  lastSelectedPriceClassId: 0,
  priceClassList: [] // Below PriceClassList here.
}

export const priceClassList= {
      priceClassId: 0,
      priceClassName: '',
      serviceOfferingList: []
}
